/**
 * Common disposable email domains (browser-compatible)
 */
const disposableDomains = new Set([
  '10minutemail.com', 'tempmail.org', 'guerrillamail.com', 'mailinator.com',
  'throwaway.email', 'temp-mail.org', 'yopmail.com', 'maildrop.cc',
  'sharklasers.com', 'guerrillamailblock.com', 'pokemail.net', 'spam4.me',
  'tempail.com', 'tempinbox.com', 'tmpeml.com', 'tempemailaddress.com',
  'dispostable.com', 'fakeinbox.com', 'hidemail.de', 'mytrashmail.com',
  'no-spam.ws', 'nospam.ze.tc', 'nowmymail.com', 'objectmail.com',
  'pookmail.com', 'sogetthis.com', 'spamherelots.com', 'superrito.com',
  'suremail.info', 'tempemail.co.za', 'tempmail.it', 'trashmail.at',
  'trashmail.com', 'trashmail.io', 'trashmail.me', 'trashmail.net',
  'wegwerfmail.de', 'wegwerfmail.net', 'wegwerfmail.org', 'zehnminuten.de'
]);

/**
 * Common typos in email domains with their corrections
 */
const domainTypos = new Map([
  // Gmail variations
  ['gmai.com', 'gmail.com'],
  ['gmial.com', 'gmail.com'],
  ['gmaill.com', 'gmail.com'],
  ['gmail.co', 'gmail.com'],
  ['gmail.con', 'gmail.com'],
  ['gmil.com', 'gmail.com'],
  ['gmai.co', 'gmail.com'],
  ['gmal.com', 'gmail.com'],
  ['gmali.com', 'gmail.com'],
  ['gmail.cm', 'gmail.com'],
  ['gmail.om', 'gmail.com'],
  ['gmail.cmo', 'gmail.com'],
  ['gamil.com', 'gmail.com'],
  ['gmaol.com', 'gmail.com'],
  ['gmeil.com', 'gmail.com'],
  ['gmailcom', 'gmail.com'],
  ['g-mail.com', 'gmail.com'],
  ['gmai;.com', 'gmail.com'],

  // Yahoo variations
  ['yaho.com', 'yahoo.com'],
  ['yahoo.co', 'yahoo.com'],
  ['yahoo.con', 'yahoo.com'],
  ['yahooo.com', 'yahoo.com'],
  ['yhoo.com', 'yahoo.com'],
  ['ymail.co', 'ymail.com'],
  ['yaoo.com', 'yahoo.com'],
  ['yahoo.cm', 'yahoo.com'],
  ['yahoo.om', 'yahoo.com'],
  ['yaho.co', 'yahoo.com'],
  ['yhaoo.com', 'yahoo.com'],
  ['yahoo.cmo', 'yahoo.com'],
  ['yahho.com', 'yahoo.com'],
  ['yaho0.com', 'yahoo.com'],
  ['yahooo.co', 'yahoo.com'],
  ['yahoocom', 'yahoo.com'],
  ['ymail.con', 'ymail.com'],
  ['ymai.com', 'ymail.com'],

  // Hotmail/Outlook variations
  ['hotmial.com', 'hotmail.com'],
  ['hotmai.com', 'hotmail.com'],
  ['hotmall.com', 'hotmail.com'],
  ['hotmail.co', 'hotmail.com'],
  ['hotmail.con', 'hotmail.com'],
  ['hotmailcom', 'hotmail.com'],
  ['hotmai.co', 'hotmail.com'],
  ['hotmal.com', 'hotmail.com'],
  ['hotmil.com', 'hotmail.com'],
  ['hotmaill.com', 'hotmail.com'],
  ['hotmail.cm', 'hotmail.com'],
  ['hotmail.om', 'hotmail.com'],
  ['hotmael.com', 'hotmail.com'],
  ['hotmial.co', 'hotmail.com'],
  ['outlok.com', 'outlook.com'],
  ['outlook.co', 'outlook.com'],
  ['outlook.con', 'outlook.com'],
  ['outlookk.com', 'outlook.com'],
  ['outllok.com', 'outlook.com'],
  ['outlookcom', 'outlook.com'],
  ['outlook.cm', 'outlook.com'],
  ['outlook.om', 'outlook.com'],
  ['outloook.com', 'outlook.com'],
  ['outlok.co', 'outlook.com'],

  // Live/MSN variations
  ['live.co', 'live.com'],
  ['live.con', 'live.com'],
  ['live.cm', 'live.com'],
  ['live.om', 'live.com'],
  ['liv.com', 'live.com'],
  ['livecom', 'live.com'],
  ['msn.co', 'msn.com'],
  ['msn.con', 'msn.com'],
  ['msn.cm', 'msn.com'],
  ['msncom', 'msn.com'],

  // Apple/iCloud variations
  ['iclod.com', 'icloud.com'],
  ['icloud.co', 'icloud.com'],
  ['iclooud.com', 'icloud.com'],
  ['icloud.con', 'icloud.com'],
  ['icloud.cm', 'icloud.com'],
  ['icloud.om', 'icloud.com'],
  ['icloudcom', 'icloud.com'],
  ['icoud.com', 'icloud.com'],
  ['iclud.com', 'icloud.com'],
  ['me.co', 'me.com'],
  ['me.con', 'me.com'],
  ['me.cm', 'me.com'],
  ['mac.co', 'mac.com'],
  ['mac.con', 'mac.com'],

  // AOL variations
  ['aol.co', 'aol.com'],
  ['aol.con', 'aol.com'],
  ['aoil.com', 'aol.com'],
  ['aol.cm', 'aol.com'],
  ['aol.om', 'aol.com'],
  ['aolcom', 'aol.com'],
  ['ao.com', 'aol.com'],

  // Comcast variations
  ['comcast.co', 'comcast.net'],
  ['comcast.com', 'comcast.net'],
  ['comast.net', 'comcast.net'],
  ['comcas.net', 'comcast.net'],
  ['comcast.nt', 'comcast.net'],

  // Verizon variations
  ['verizon.co', 'verizon.net'],
  ['verizon.com', 'verizon.net'],
  ['verison.net', 'verizon.net'],
  ['verzion.net', 'verizon.net'],

  // AT&T variations
  ['att.co', 'att.net'],
  ['att.com', 'att.net'],
  ['at.net', 'att.net'],
  ['att.nt', 'att.net'],

  // Common TLD typos
  ['gmail.co', 'gmail.com'],
  ['yahoo.co', 'yahoo.com'],
  ['hotmail.co', 'hotmail.com'],
  ['outlook.co', 'outlook.com'],

  // Generic common typos
  ['.co', '.com'],
  ['.con', '.com'],
  ['.cm', '.com'],
  ['.om', '.com'],
  ['.cmo', '.com'],
  ['.nt', '.net'],
  ['.nte', '.net'],
  ['.org', '.org'], // Keep this as is

  // International domains
  // ['gmail.co.uk', 'gmail.com'], // Usually people mean gmail.com
  // ['yahoo.co.uk', 'yahoo.co.uk'], // Keep this as is - valid domain
  // ['hotmail.co.uk', 'hotmail.co.uk'], // Keep this as is - valid domain

  // Other popular services
  ['protonmail.co', 'protonmail.com'],
  ['protonmai.com', 'protonmail.com'],
  ['protonmial.com', 'protonmail.com'],
  ['tutanota.co', 'tutanota.com'],
  ['tutanotacom', 'tutanota.com'],
  ['zoho.co', 'zoho.com'],
  ['zohocom', 'zoho.com'],
  ['fastmail.co', 'fastmail.com'],
  ['fastmailcom', 'fastmail.com']
]);

/**
 * Validates email using comprehensive regex pattern
 */
function validateRegex(email) {
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  const hasValidLength = email.length <= 254;
  const localPart = email.split('@')[0];
  const hasValidLocalLength = localPart && localPart.length <= 64;
  const hasValidFormat = emailRegex.test(email);
  const hasNoDotAtStart = !email.startsWith('.');
  const hasNoDotAtEnd = !email.endsWith('.');
  const hasNoConsecutiveDots = !email.includes('..');

  const isValid = hasValidLength && hasValidLocalLength && hasValidFormat &&
    hasNoDotAtStart && hasNoDotAtEnd && hasNoConsecutiveDots;

  let reason = null;
  if (!hasValidFormat) reason = 'Invalid email format';
  else if (!hasValidLength) reason = 'Email too long';
  else if (!hasValidLocalLength) reason = 'Local part too long';
  else if (hasNoDotAtStart || hasNoDotAtEnd) reason = 'Invalid dot placement';
  else if (!hasNoConsecutiveDots) reason = 'Consecutive dots not allowed';

  return { valid: isValid, reason: reason };
}

/**
 * Validates email domain format
 */
function validateDomain(email) {
  const parts = email.split('@');
  if (parts.length !== 2) {
    return { valid: false, reason: 'Invalid email structure' };
  }

  const domain = parts[1].toLowerCase();
  const domainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  const hasValidDomainFormat = domainRegex.test(domain);
  const hasTLD = domain.includes('.') && domain.split('.').pop().length >= 2;
  const hasValidTLD = /^[a-zA-Z]{2,}$/.test(domain.split('.').pop());

  if (!hasValidDomainFormat) {
    return { valid: false, reason: 'Invalid domain format' };
  }

  if (!hasTLD || !hasValidTLD) {
    return { valid: false, reason: 'Invalid or missing TLD' };
  }

  return { valid: true };
}

/**
 * Checks for common typos in email domains
 */
function validateTypo(email) {
  const domain = email.split('@')[1];
  if (!domain) {
    return { valid: false, reason: 'No domain found' };
  }

  const lowerDomain = domain.toLowerCase();

  if (domainTypos.has(lowerDomain)) {
    const suggestion = domainTypos.get(lowerDomain);
    return {
      valid: false,
      reason: `Did you mean ${suggestion}?`,
      suggestion: email.replace(domain, suggestion)
    };
  }

  return { valid: true };
}

/**
 * Checks if email is from a disposable email service
 */
function validateDisposable(email) {
  const domain = email.split('@')[1];
  if (!domain) {
    return { valid: false, reason: 'No domain found' };
  }

  const lowerDomain = domain.toLowerCase();
  const isDisposable = disposableDomains.has(lowerDomain);

  return {
    valid: !isDisposable,
    reason: isDisposable ? 'Disposable email address detected' : null
  };
}

/**
 * Main email validation function - returns boolean for backward compatibility
 */
const validateEmail = (email, checkTypo = true) => {
  if (!email || typeof email !== 'string') {
    return false;
  }

  // Basic format check
  const basicValid = validateRegex(email).valid;
  if (!basicValid) return false;

  // Domain check
  const domainValid = validateDomain(email).valid;
  if (!domainValid) return false;

  // Typo check
  if (checkTypo) {
    const typoCheck = validateTypo(email);
    if (!typoCheck.valid) {
      console.warn(typoCheck.reason);
      return false;
    }

    // Disposable check
    const disposableCheck = validateDisposable(email);
    if (!disposableCheck.valid) {
      console.warn(disposableCheck.reason);
      return false;
    }
  }

  return true;
};

/**
 * Enhanced email validation with detailed results
 */
const validateEmailEnhanced = async (email, options = {}) => {
  const defaultOptions = {
    validateRegex: true,
    validateDomain: true,
    validateTypo: true,
    validateDisposable: true
  };

  const config = { ...defaultOptions, ...options };

  if (!email || typeof email !== 'string') {
    return {
      isValid: false,
      reason: 'invalid_input',
      validators: {}
    };
  }

  try {
    const validators = {};

    if (config.validateRegex) {
      validators.regex = validateRegex(email);
    }

    if (config.validateDomain) {
      validators.domain = validateDomain(email);
    }

    if (config.validateTypo) {
      validators.typo = validateTypo(email);
    }

    if (config.validateDisposable) {
      validators.disposable = validateDisposable(email);
    }

    const isValid = Object.values(validators).every(result => result.valid);

    let reason = null;
    for (const [key, result] of Object.entries(validators)) {
      if (!result.valid) {
        reason = key;
        break;
      }
    }

    return {
      isValid,
      reason,
      validators,
      suggestion: validators.typo?.suggestion || null
    };
  } catch (error) {
    return {
      isValid: false,
      reason: 'validation_error',
      error: error.message,
      validators: {}
    };
  }
};

export {
  validateEmail,
  validateEmailEnhanced,
  validateRegex,
  validateDomain,
  validateTypo,
  validateDisposable,
  disposableDomains,
  domainTypos
};
